/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Section_Programs_AccentInputs */

const en_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`for every player.`)
};

const es_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`para cada jugador.`)
};

const de_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`für jeden Spieler.`)
};

const zh_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`量身定制的课程。`)
};

const ar_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لكل لاعب.`)
};

const fr_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pour chaque joueur.`)
};

const vi_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cho mọi người chơi.`)
};

const sw_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kwa kila mchezaji.`)
};

const th_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สำหรับผู้เล่นทุกคน`)
};

const bs_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`za svakog igrača.`)
};

const ja_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プログラム。`)
};

const ko_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프로그램.`)
};

const pt_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`para cada jogador.`)
};

const it_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per ogni giocatore.`)
};

const sv_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`för varje spelare.`)
};

const nl_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`voor elke speler.`)
};

const da_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`for hver spiller.`)
};

const nb_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`for hver spiller.`)
};

const fi_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jokaiselle pelaajalle.`)
};

const pl_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dla każdego gracza.`)
};

const ru_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`для каждого игрока.`)
};

const tr_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`uygun bir program.`)
};

const hi_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रत्येक खिलाड़ी के लिए।`)
};

const id_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`untuk setiap pemain.`)
};

const ms_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`untuk setiap pemain.`)
};

const cs_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pro každého hráče.`)
};

const el_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`για κάθε παίκτη.`)
};

const he_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לכל שחקן.`)
};

const af_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vir elke speler.`)
};

const hu_home_section_programs_accent = /** @type {(inputs: Home_Section_Programs_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`minden játékosnak.`)
};

/**
* | output |
* | --- |
* | "for every player." |
*
* @param {Home_Section_Programs_AccentInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_section_programs_accent = /** @type {((inputs?: Home_Section_Programs_AccentInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Section_Programs_AccentInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_section_programs_accent(inputs)
	if (locale === "de") return de_home_section_programs_accent(inputs)
	if (locale === "zh") return zh_home_section_programs_accent(inputs)
	if (locale === "ar") return ar_home_section_programs_accent(inputs)
	if (locale === "fr") return fr_home_section_programs_accent(inputs)
	if (locale === "vi") return vi_home_section_programs_accent(inputs)
	if (locale === "sw") return sw_home_section_programs_accent(inputs)
	if (locale === "th") return th_home_section_programs_accent(inputs)
	if (locale === "bs") return bs_home_section_programs_accent(inputs)
	if (locale === "ja") return ja_home_section_programs_accent(inputs)
	if (locale === "ko") return ko_home_section_programs_accent(inputs)
	if (locale === "pt") return pt_home_section_programs_accent(inputs)
	if (locale === "it") return it_home_section_programs_accent(inputs)
	if (locale === "sv") return sv_home_section_programs_accent(inputs)
	if (locale === "nl") return nl_home_section_programs_accent(inputs)
	if (locale === "da") return da_home_section_programs_accent(inputs)
	if (locale === "nb") return nb_home_section_programs_accent(inputs)
	if (locale === "fi") return fi_home_section_programs_accent(inputs)
	if (locale === "pl") return pl_home_section_programs_accent(inputs)
	if (locale === "ru") return ru_home_section_programs_accent(inputs)
	if (locale === "tr") return tr_home_section_programs_accent(inputs)
	if (locale === "hi") return hi_home_section_programs_accent(inputs)
	if (locale === "id") return id_home_section_programs_accent(inputs)
	if (locale === "ms") return ms_home_section_programs_accent(inputs)
	if (locale === "cs") return cs_home_section_programs_accent(inputs)
	if (locale === "el") return el_home_section_programs_accent(inputs)
	if (locale === "he") return he_home_section_programs_accent(inputs)
	if (locale === "af") return af_home_section_programs_accent(inputs)
	if (locale === "hu") return hu_home_section_programs_accent(inputs)
	return en_home_section_programs_accent(inputs)
});